import pdfMake from 'pdfmake/build/pdfmake'

// ─── Cores dos substatus ──────────────────────────────────────────────────────

const substatusColors = {
  'AGUARDANDO COMPRA': { bg: '#fef3c7', text: '#92400e' },
  'COMPRADO / A RECEBER': { bg: '#dbeafe', text: '#1e40af' },
  'PRODUTO EM FALTA': { bg: '#fee2e2', text: '#991b1b' },
  SHOWROOM: { bg: '#d1fae5', text: '#065f46' },
}

const statusColors = {
  'AGUARDANDO SEPARAÇÃO': { bg: '#fef3c7', text: '#92400e' },
  'ARMAZENADO COM FALTA': { bg: '#fee2e2', text: '#991b1b' },
  'ARMAZENADO COMPLETO': { bg: '#d1fae5', text: '#065f46' },
  ENTREGUE: { bg: '#ede9fe', text: '#5b21b6' },
}

// ─── Helper: formata data ─────────────────────────────────────────────────────

function formatDate(value) {
  if (!value) return '—'
  return new Date(value).toLocaleDateString('pt-BR')
}

// ─── Helper: badge de status (fill colorido) ──────────────────────────────────

function statusBadge(label, colorMap) {
  const colors = colorMap[label] || { bg: '#f0ede8', text: '#444444' }
  // pdfmake não suporta border-radius, simulamos com fillColor no canvas
  return {
    table: {
      body: [
        [
          {
            text: label,
            fontSize: 7,
            bold: true,
            color: colors.text,
            fillColor: colors.bg,
            margin: [4, 2, 4, 2],
            border: [false, false, false, false],
          },
        ],
      ],
    },
    layout: 'noBorders',
    margin: [0, 1, 0, 1],
  }
}

// ─── Gerador principal ────────────────────────────────────────────────────────

export function gerarRelatorioPDF(pedidos) {
  const agora = new Date().toLocaleString('pt-BR')
  const total = pedidos.length

  // ── Conteúdo dinâmico: um bloco por pedido ──────────────────────────────────
  const blocosPedidos = pedidos.flatMap((pedido, idx) => {
    // Cabeçalho do pedido
    const cabecalhoPedido = {
      table: {
        widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
        body: [
          [
            {
              text: `#\n${idx + 1}`,
              fontSize: 8,
              bold: true,
              color: '#555555',
              border: [true, true, false, true],
              fillColor: '#f8f7f3',
              margin: [6, 6, 6, 6],
            },
            {
              stack: [
                {
                  text: 'PED. LOJA',
                  fontSize: 7,
                  color: '#999999',
                  bold: true,
                },
                {
                  text: String(pedido.idpedidoloja),
                  fontSize: 11,
                  bold: true,
                  color: '#1a1a1a',
                },
              ],
              border: [false, true, false, true],
              fillColor: '#f8f7f3',
              margin: [6, 6, 6, 6],
            },
            {
              stack: [
                {
                  text: 'PED. MATRIZ',
                  fontSize: 7,
                  color: '#999999',
                  bold: true,
                },
                {
                  text: String(pedido.pedido_matriz ?? '—'),
                  fontSize: 9,
                  color: '#555555',
                },
                {
                  text: 'CLIENTE',
                  fontSize: 7,
                  color: '#999999',
                  bold: true,
                  margin: [0, 4, 0, 0],
                },
                {
                  text: pedido.cliente ?? '—',
                  fontSize: 9,
                  bold: true,
                  color: '#1a1a1a',
                },
              ],
              border: [false, true, false, true],
              fillColor: '#f8f7f3',
              margin: [6, 6, 6, 6],
            },
            {
              stack: [
                { text: 'DATA', fontSize: 7, color: '#999999', bold: true },
                {
                  text: formatDate(pedido.data_pedido),
                  fontSize: 9,
                  color: '#555555',
                },
              ],
              border: [false, true, false, true],
              fillColor: '#f8f7f3',
              margin: [6, 6, 6, 6],
            },
            {
              stack: [
                { text: 'ENTREGA', fontSize: 7, color: '#999999', bold: true },
                {
                  text: formatDate(pedido.data_entrega),
                  fontSize: 9,
                  color: '#555555',
                },
              ],
              border: [false, true, false, true],
              fillColor: '#f8f7f3',
              margin: [6, 6, 6, 6],
            },
            {
              stack: [
                {
                  text: 'ARMAZENADO',
                  fontSize: 7,
                  color: '#999999',
                  bold: true,
                },
                {
                  text: formatDate(pedido.data_armazenado),
                  fontSize: 9,
                  color: '#555555',
                },
              ],
              border: [false, true, false, true],
              fillColor: '#f8f7f3',
              margin: [6, 6, 6, 6],
            },
            {
              stack: [
                { text: 'CIDADE', fontSize: 7, color: '#999999', bold: true },
                { text: pedido.cidade ?? '—', fontSize: 9, color: '#555555' },
              ],
              border: [false, true, false, true],
              fillColor: '#f8f7f3',
              margin: [6, 6, 6, 6],
            },
            {
              text: '',
              border: [false, true, true, true],
              fillColor: '#f8f7f3',
              margin: [0, 0, 0, 0],
            },
          ],
        ],
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0,
        hLineColor: () => '#e8e6e0',
        vLineColor: () => '#e8e6e0',
      },
      margin: [0, 0, 0, 0],
    }

    // Linha do status
    const linhaStatus = {
      table: {
        widths: ['*'],
        body: [
          [
            {
              stack: [
                {
                  text: 'STATUS',
                  fontSize: 7,
                  color: '#999999',
                  bold: true,
                  margin: [0, 0, 0, 3],
                },
                statusBadge(pedido.status_nome, statusColors),
              ],
              border: [true, false, true, true],
              fillColor: '#ffffff',
              margin: [8, 6, 8, 8],
            },
          ],
        ],
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
        hLineColor: () => '#e8e6e0',
        vLineColor: () => '#e8e6e0',
      },
      margin: [0, 0, 0, 0],
    }

    // Tabela de produtos
    const produtos = pedido.produtos ?? []

    const headerProdutos = [
      {
        text: 'CÓDIGO',
        fontSize: 7,
        bold: true,
        color: '#999999',
        fillColor: '#f8f7f3',
        margin: [6, 5, 6, 5],
        border: [true, true, true, true],
      },
      {
        text: 'DESCRIÇÃO',
        fontSize: 7,
        bold: true,
        color: '#999999',
        fillColor: '#f8f7f3',
        margin: [6, 5, 6, 5],
        border: [false, true, true, true],
      },
      {
        text: 'QTD',
        fontSize: 7,
        bold: true,
        color: '#999999',
        fillColor: '#f8f7f3',
        margin: [6, 5, 6, 5],
        border: [false, true, true, true],
      },
      {
        text: 'SUBSTATUS',
        fontSize: 7,
        bold: true,
        color: '#999999',
        fillColor: '#f8f7f3',
        margin: [6, 5, 6, 5],
        border: [false, true, true, true],
      },
      {
        text: 'OBSERVAÇÃO',
        fontSize: 7,
        bold: true,
        color: '#999999',
        fillColor: '#f8f7f3',
        margin: [6, 5, 6, 5],
        border: [false, true, true, true],
      },
    ]

    const linhasProdutos =
      produtos.length > 0
        ? produtos.map((prod) => {
            return [
              {
                text: prod.codigo ?? '—',
                fontSize: 8,
                color: '#2a2a2a',
                margin: [6, 6, 6, 6],
                border: [true, false, true, true],
              },
              {
                text: prod.descricao ?? '—',
                fontSize: 8,
                color: '#2a2a2a',
                margin: [6, 6, 6, 6],
                border: [false, false, true, true],
              },
              {
                text: String(prod.qtd ?? '—'),
                fontSize: 8,
                color: '#2a2a2a',
                margin: [6, 6, 6, 6],
                border: [false, false, true, true],
              },
              {
                stack: [statusBadge(prod.substatus, substatusColors)],
                margin: [6, 4, 6, 4],
                border: [false, false, true, true],
              },
              {
                text: prod.obs ?? '',
                fontSize: 8,
                color: '#555555',
                margin: [6, 6, 6, 6],
                border: [false, false, true, true],
              },
            ]
          })
        : [
            [
              {
                text: 'Nenhum produto cadastrado.',
                fontSize: 8,
                color: '#aaaaaa',
                colSpan: 5,
                alignment: 'center',
                margin: [6, 10, 6, 10],
                border: [true, false, true, true],
              },
              {},
              {},
              {},
              {},
            ],
          ]

    const tabelaProdutos = {
      table: {
        widths: [60, '*', 30, 90, 90],
        body: [headerProdutos, ...linhasProdutos],
      },
      layout: {
        hLineWidth: (i) => (i === 0 ? 0.5 : 0.3),
        vLineWidth: () => 0.3,
        hLineColor: () => '#e8e6e0',
        vLineColor: () => '#e8e6e0',
      },
      margin: [0, 0, 0, idx < pedidos.length - 1 ? 16 : 0],
    }

    return [cabecalhoPedido, linhaStatus, tabelaProdutos]
  })

  // ── Definição do documento ──────────────────────────────────────────────────

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [30, 50, 30, 50],

    header: {
      columns: [
        {
          stack: [
            {
              text: 'BELA HOME — Relatório de Pedidos',
              fontSize: 13,
              bold: true,
              color: '#1a1a1a',
            },
            {
              text: `Gerado em: ${agora}`,
              fontSize: 8,
              color: '#888888',
              margin: [0, 2, 0, 0],
            },
          ],
          margin: [30, 16, 0, 0],
        },
        {
          text: `Total: ${total} pedido(s)`,
          fontSize: 9,
          bold: true,
          color: '#c8a030',
          alignment: 'right',
          margin: [0, 20, 30, 0],
        },
      ],
    },

    footer: (currentPage, pageCount) => ({
      columns: [
        {
          text: `Total de pedidos: ${total}`,
          fontSize: 8,
          color: '#888888',
          margin: [30, 0, 0, 0],
        },
        {
          text: `Bela Home — Controle de Pedidos   ${currentPage} / ${pageCount}`,
          fontSize: 8,
          color: '#888888',
          alignment: 'right',
          margin: [0, 0, 30, 0],
        },
      ],
      margin: [0, 10, 0, 0],
    }),

    content: [
      // Linha separadora abaixo do header
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 535,
            y2: 0,
            lineWidth: 0.5,
            lineColor: '#e8e6e0',
          },
        ],
        margin: [0, 0, 0, 16],
      },
      ...blocosPedidos,
    ],

    defaultStyle: {
      font: 'Roboto',
      fontSize: 9,
      color: '#1a1a1a',
    },
  }

  pdfMake.createPdf(docDefinition).open()
}
